import { Paper } from '@material-ui/core';
import { SecondaryAlert, SecondaryButton, useTimedAlerts } from 'kagr-ui';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSegmentsFilters } from '../../hooks/useSegmentsFilters';
import Paths from '../../models/enums/paths';
import { SegmentFilters } from '../../models/segments';
import { TableSortState } from '../../models/tableSortState';
import SegmentsSidebar from './filter-sidebar/segments-sidebar';
import SegmentsTable from './overview/segments-table';
import * as styles from './segments.module.scss';

export enum SegmentSortFields {
  Name = 'name',
  LastModified = 'lastModifiedDate',
  CreatedBy = 'createdByName',
  Customers = 'customers',
  Sharing = 'isShared'
}

export const defaultActiveFilters: SegmentFilters = {
  startDate: null,
  endDate: null,
  min: '',
  max: '',
  isShared: [],
  users: []
};

export const clientSegmentsHeaders = [
  {
    title: 'Name',
    orderField: SegmentSortFields.Name
  },
  {
    title: 'Modified Date',
    orderField: SegmentSortFields.LastModified
  },
  {
    title: 'Description'
  },
  {
    title: '# of Customers',
    orderField: SegmentSortFields.Customers
  },
  {
    title: 'Created By',
    orderField: SegmentSortFields.CreatedBy
  },
  {
    title: 'Sharing',
    orderField: SegmentSortFields.Sharing
  }
];

const initialSortState: TableSortState = {
  page: 1,
  pageSize: 15,
  orderColumn: SegmentSortFields.LastModified,
  orderDirection: 'desc'
};

/**
 * User view of the available segments table
 */
const Segments = () => {
  const [activeFilters, setActiveFilters] = React.useState<SegmentFilters>(defaultActiveFilters);
  const filtersQuery = useSegmentsFilters();
  const history = useHistory();
  const location = useLocation<{ successMessage?: string }>();
  const { successMessage, setSuccessMessage } = useTimedAlerts();

  React.useEffect(() => {
    if (location.state && location.state.successMessage) {
      setSuccessMessage(location.state.successMessage);
      // Reset the scroll to the top of the segment overview in case the scroll state was changed while updating the segment
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [location.state]);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1>Segments</h1>
        <SecondaryButton
          text="Create New Segment"
          handleClick={() => {
            history.push(Paths.NewSegment);
          }}
        />
      </div>
      {successMessage && <SecondaryAlert type="success" message={successMessage} />}
      <Paper elevation={1} className={styles.paper}>
        <SegmentsSidebar
          setActiveFilters={setActiveFilters}
          defaultActiveFilters={defaultActiveFilters}
          isLoading={filtersQuery.isLoading}
          loadedFilters={filtersQuery.data}
        />
        <SegmentsTable
          columnHeaders={clientSegmentsHeaders}
          initialSortState={initialSortState}
          activeFilters={activeFilters}
        />
      </Paper>
    </div>
  );
};

export default Segments;
